"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClubInvoiceComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useClubInvoice_1 = require("./context/useClubInvoice");
const table_1 = require("../../components/web-view/table");
const FilterContext_1 = require("../../context/filters/FilterContext");
const usePagination_1 = require("../../hooks/pagination/usePagination");
const clubInvoice_module_scss_1 = __importDefault(require("./clubInvoice.module.scss"));
const button_1 = require("primereact/button");
const react_router_dom_1 = require("react-router-dom");
const FiltersComponent_1 = require("../../components/filter/FiltersComponent");
const datesHelpers_1 = require("../../common/utils/datesHelpers");
const react_i18next_1 = require("react-i18next");
const useDebounce_1 = require("../../hooks/debounce/useDebounce");
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const ClubInvoiceList_1 = require("./mobile/ClubInvoiceList");
const RecalculateModal_1 = require("./admin-settings/RecalculateModal");
const dayjs_1 = __importDefault(require("dayjs"));
const dateHelpers_1 = require("../../components/filter/dateHelpers");
const SortOptionModal_1 = require("../orders/mobile/SortOptionModal");
const MobileListActions_1 = require("../../components/mobile/MobileListActions");
const fi_1 = require("react-icons/fi");
const useClubMachineFilter_1 = require("../../hooks/filters/useClubMachineFilter");
const FilterButton_1 = require("../../components/filter/filter-button/FilterButton");
const ActiveFilterChips_1 = require("../../components/chip/ActiveFilterChips");
const MobileFilterModal_1 = require("../../components/filter/filter-button/MobileFilterModal");
const MobilePillFilter_1 = require("../../components/filter/filter-button/MobilePillFilter");
const ClubInvoiceComponent = () => {
    const { filters, setFilters } = (0, FilterContext_1.useFilters)();
    const [showInvoiceModal, setShowInvoiceModal] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [isFirstLoad, setIsFirstLoad] = (0, react_1.useState)(true);
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const [globalFilterValue, setGlobalFilterValue] = (0, react_1.useState)(filters.globalFilterValue || '');
    const debouncedFilterValue = (0, useDebounce_1.useDebounce)(globalFilterValue, 500);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(() => {
        const storedPage = localStorage.getItem('currentPage');
        return storedPage ? parseInt(storedPage, 10) : 1;
    });
    const localStorageFilters = JSON.parse(localStorage.getItem('filters') || '{}');
    const [selectedPeriod, setSelectedPeriod] = (0, react_1.useState)({
        month: localStorageFilters.month || '',
        year: localStorageFilters.year || new Date().getFullYear(),
    });
    const [selectedPeriodRecalculate, setSelectedPeriodRecalculate] = (0, react_1.useState)({
        month: localStorageFilters.month || '',
        year: localStorageFilters.year || new Date().getFullYear(),
    });
    const [dateFilter, setDateFilter] = (0, react_1.useState)(localStorageFilters.startDate && localStorageFilters.endDate
        ? [
            new Date(localStorageFilters.startDate),
            new Date(localStorageFilters.endDate),
        ]
        : datesHelpers_1.getDefaultDateRangeArray);
    const [sortField, setSortField] = (0, react_1.useState)('issueDate');
    const [sortOrder, setSortOrder] = (0, react_1.useState)(-1);
    const [showSortModal, setShowSortModal] = (0, react_1.useState)(false);
    const [invoiceTypeFilter, setInvoiceTypeFilter] = (0, react_1.useState)(localStorageFilters.invoiceType || '');
    const options = (0, react_1.useMemo)(() => [
        { field: 'issueDate', label: t('date') },
        { field: 'invoiceNumber', label: t('invoice') },
        { field: 'machineName', label: t('machineNameSort') },
        { field: 'clubName', label: t('club') },
    ], [t]);
    const invoiceTypeFilterItems = (0, react_1.useMemo)(() => [
        {
            name: t('invoiceType.PERSONAL'),
            value: 'PERSONAL',
            description: t('invoiceType.PERSONALDescription'),
            icon: (0, jsx_runtime_1.jsx)(fi_1.FiUser, { size: 18, style: { padding: 0 }, className: "!p-0" }),
            selectedClasses: 'bg-blue-100 border-blue-500 text-blue-700',
        },
        {
            name: t('invoiceType.ANONYMOUS'),
            value: 'ANONYMOUS',
            description: t('invoiceType.RECAPITULATEDescription'),
            icon: (0, jsx_runtime_1.jsx)(fi_1.FiFileText, { size: 18 }),
            selectedClasses: 'bg-green-100 border-green-500 text-green-700',
        },
    ], [t]);
    const { getAll } = (0, useClubInvoice_1.useClubInvoice)();
    const { tableFilters, displayFilters, filterFields, getFilterFields, optionsMap, handleTableFilterChange, handleRemoveFilter, handleClearAllFilters, displayActiveFilterCount, showMobileFilters, setShowMobileFilters, } = (0, useClubMachineFilter_1.useClubMachineFilter)({
        storageKey: 'clubInvoice',
        onFilterChange: () => {
            setCurrentPage(1);
            localStorage.setItem('currentPage', '1');
        },
    });
    const tableFiltersRef = (0, react_1.useRef)(tableFilters);
    (0, react_1.useEffect)(() => {
        tableFiltersRef.current = tableFilters;
    }, [tableFilters]);
    const fetchStateRef = (0, react_1.useRef)({
        invoiceTypeFilter,
        sortField,
        sortOrder,
        filters,
        getAll,
    });
    fetchStateRef.current = {
        invoiceTypeFilter,
        sortField,
        sortOrder,
        filters,
        getAll,
    };
    const fetchClubInvoices = (0, react_1.useCallback)(async (page, pageSize, filter) => {
        const { invoiceTypeFilter, sortField, sortOrder, filters, getAll } = fetchStateRef.current;
        const fromDate = filters.startDate
            ? Math.floor(new Date(filters.startDate).getTime() / 1000).toString()
            : undefined;
        const toDate = filters.endDate
            ? Math.floor(new Date(filters.endDate).getTime() / 1000).toString()
            : undefined;
        const sort = [
            {
                field: sortField,
                direction: sortOrder === 1 ? 'asc' : 'desc',
            },
        ];
        const invoiceType = invoiceTypeFilter || undefined;
        if (fromDate && toDate)
            try {
                return await getAll(page, pageSize, filter, fromDate, toDate, sort, invoiceType, tableFiltersRef.current.machines || [], tableFiltersRef.current.clubs || []);
            }
            catch (error) {
                console.error('Error fetching club invoices:', error);
            }
    }, []);
    const { data, loading, fetchData } = (0, usePagination_1.usePagination)(parseInt(localStorage.getItem('currentPage') || '1', 10), 10, (page, pageSize, debounceFilterValue) => fetchClubInvoices(page, pageSize, debounceFilterValue || ''), (item) => item.invoiceId);
    (0, react_1.useEffect)(() => {
        if (isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        if (!filters.startDate || !filters.endDate || showInvoiceModal)
            return;
        fetchData(currentPage, 10, false, debouncedFilterValue, [], [], filters.startDate, filters.endDate, selectedPeriod.year, selectedPeriod.month);
    }, [
        filters.startDate,
        filters.endDate,
        debouncedFilterValue,
        selectedPeriod.month,
        selectedPeriod.year,
        currentPage,
        isFirstLoad,
        showInvoiceModal,
        sortField,
        sortOrder,
        invoiceTypeFilter,
        tableFilters,
    ]);
    // Actualización de filtros globales con debounce
    (0, react_1.useEffect)(() => {
        if (debouncedFilterValue !== undefined) {
            setFilters((prevFilters) => ({
                ...prevFilters,
                globalFilterValue: debouncedFilterValue,
            }));
        }
    }, [debouncedFilterValue]);
    const columns = (0, react_1.useMemo)(() => [
        {
            field: 'issueDate',
            header: 'date',
            renderFunc: (cil) => {
                if (!cil.billingPeriod)
                    return '';
                const start = (0, dayjs_1.default)(cil.billingPeriod.startDate).format('DD/MM/YYYY');
                const end = (0, dayjs_1.default)(cil.billingPeriod.endDate).format('DD/MM/YYYY');
                return (0, jsx_runtime_1.jsx)("span", { children: `${start} - ${end}` });
            },
        },
        {
            field: 'invoiceType',
            header: 'type',
            renderFunc: (cil) => {
                if (!cil.invoiceType)
                    return '';
                return (0, jsx_runtime_1.jsx)("span", { children: t(`invoiceType.${cil.invoiceType}`) });
            },
        },
        {
            field: 'machineName',
            header: 'machine',
            renderFunc: (cil) => {
                if (!cil.machineName)
                    return '';
                return (0, jsx_runtime_1.jsx)("span", { children: cil.machineName });
            },
        },
        {
            field: 'clubName',
            header: 'club',
            renderFunc: (cil) => {
                if (!cil.clubName)
                    return '';
                return (0, jsx_runtime_1.jsx)("span", { children: cil.clubName });
            },
        },
        {
            field: 'netPayout',
            header: 'amount',
            renderFunc: (cil) => {
                if (cil.netPayout === undefined)
                    return '';
                return ((0, jsx_runtime_1.jsxs)("span", { children: [cil.netPayout.toFixed(2), " ", cil.currency ?? 'EUR'] }));
            },
        },
    ], [t]);
    const handlerGotoDetail = (0, react_1.useCallback)((cil) => {
        navigate(`/billing/${cil.invoiceId}`);
    }, [navigate]);
    const renderActionButtons = (0, react_1.useCallback)((cil) => ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-center gap-2", children: (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-eye", className: "p-button-rounded p-button-info p-button-outlined", onClick: () => handlerGotoDetail(cil) }) })), [handlerGotoDetail]);
    const onGlobalFilterChange = (e) => {
        const getFilters = JSON.parse(localStorage.getItem('filters') || '{}');
        const newFilters = {
            ...getFilters,
            globalFilterValue: e,
            clubId: filters.clubId,
        };
        // Actualiza solo el estado local para debounce
        setGlobalFilterValue(e);
        setCurrentPage(1); // Reinicia la paginación
        localStorage.setItem('currentPage', '1');
        localStorage.setItem('filters', JSON.stringify(newFilters));
    };
    const handlerDateFilter = (dates) => {
        const newFilters = {
            globalFilterValue,
            startDate: dates?.[0]?.toISOString() || null,
            endDate: dates?.[1]?.toISOString() || null,
            clubId: null,
        };
        setFilters(newFilters);
        setDateFilter(dates);
        localStorage.setItem('filters', JSON.stringify(newFilters));
    };
    const handlerDateFilterRecalculate = (0, react_1.useCallback)(({ month, year }) => {
        if (selectedPeriodRecalculate.month === month &&
            selectedPeriodRecalculate.year === year) {
            return;
        }
        setSelectedPeriodRecalculate({ month, year });
    }, [selectedPeriodRecalculate]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem('currentPage', page.toString());
    };
    const handleSortChange = (field, order) => {
        setSortField(field);
        setSortOrder(order);
        setCurrentPage(1);
        localStorage.setItem('currentPage', '1');
    };
    const onConfirmRecalculate = () => {
        setShowInvoiceModal(false);
    };
    const onCancelRecalculate = () => {
        console.log('Cancelando recalculo de facturas...');
        setShowInvoiceModal(false);
    };
    const handleInvoiceTypeFilterChange = (value) => {
        setInvoiceTypeFilter(value);
        setCurrentPage(1);
        localStorage.setItem('currentPage', '1');
        const getFilters = JSON.parse(localStorage.getItem('filters') || '{}');
        const newFilters = {
            ...getFilters,
            invoiceType: value,
        };
        localStorage.setItem('filters', JSON.stringify(newFilters));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [showInvoiceModal && ((0, jsx_runtime_1.jsx)(RecalculateModal_1.RecalculateModal, { visible: showInvoiceModal, onConfirm: onConfirmRecalculate, onCancel: onCancelRecalculate, handleMonthYearChange: handlerDateFilterRecalculate, selectedMonth: selectedPeriodRecalculate })), isMobile ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MobileFilterModal_1.MobileFiltersModal, { visible: showMobileFilters, onHide: () => setShowMobileFilters(false), filters: getFilterFields, values: tableFilters, onFilterChange: handleTableFilterChange }), (0, jsx_runtime_1.jsx)(SortOptionModal_1.SortOptionsModal, { visible: showSortModal, onHide: () => setShowSortModal(false), sortField: sortField, sortOrder: sortOrder, handleSortChange: handleSortChange, options: options }), (0, jsx_runtime_1.jsx)(MobilePillFilter_1.MobilePillFilter, { filters: displayFilters, filterFields: filterFields, onRemoveFilter: handleRemoveFilter, onClearAll: handleClearAllFilters }), (0, jsx_runtime_1.jsx)(ClubInvoiceList_1.ClubInvoiceList, { orders: data.items, globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange, fetchData: fetchData, loading: loading, pagination: data.pagination, handlerDateFilter: handlerDateFilter, dateFilter: dateFilter, selectedPeriod: selectedPeriod, invoiceTypeFilterItems: invoiceTypeFilterItems, invoiceTypeFilterValue: invoiceTypeFilter, onInvoiceTypeFilterChange: handleInvoiceTypeFilterChange, quickFilters: [
                            { id: 'today', label: t('today'), range: dateHelpers_1.getTodayRange },
                            {
                                id: 'thisWeek',
                                label: t('thisWeek'),
                                range: dateHelpers_1.getThisWeekRange,
                            },
                            {
                                id: 'thisMonth',
                                label: t('thisMonth'),
                                range: dateHelpers_1.getThisMonthRange,
                            },
                        ] }), (0, jsx_runtime_1.jsx)(MobileListActions_1.MobileListActions, { actions: [
                            {
                                key: 'filter',
                                icon: 'pi pi-filter',
                                label: t('filter'),
                                onClick: () => setShowMobileFilters(true),
                                badge: displayActiveFilterCount,
                            },
                            {
                                key: 'sort',
                                icon: 'pi pi-sort-alt',
                                label: t('sort'),
                                onClick: () => setShowSortModal(true),
                            },
                        ] })] })) : ((0, jsx_runtime_1.jsx)("div", { className: clubInvoice_module_scss_1.default.container, children: (0, jsx_runtime_1.jsx)(table_1.AppTable, { columns: columns, globalFilterFields: ['machineId'], actions: renderActionButtons, data: data, fetchData: fetchData, loading: loading, getKey: (item) => item.invoiceId, currentPage: currentPage, handleCurrentPage: handlePageChange, reduceHeight: true, enableSorting: true, sortableFields: [
                        'issueDate',
                        'invoiceNumber',
                        'machineName',
                        'clubName',
                        'netPayout',
                    ], sortField: sortField, sortOrder: sortOrder, defaultSort: 'issueDate', onSortChange: handleSortChange, headerContent: (0, jsx_runtime_1.jsx)("div", { className: 'flex items-center gap-2', children: (0, jsx_runtime_1.jsx)("h2", { children: t('billingList') }) }), filtersComponent: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)(FilterButton_1.FilterButton, { filters: getFilterFields, values: tableFilters, onFilterChange: handleTableFilterChange, buttonLabel: t('') }), (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange, handlerDateFilter: handlerDateFilter, resetPageToFirst: () => setCurrentPage(1), inputFilterActive: true, invoiceTypeFilterItems: invoiceTypeFilterItems, invoiceTypeFilterValue: invoiceTypeFilter, onInvoiceTypeFilterChange: handleInvoiceTypeFilterChange, showInvoiceTypeIconsInDesktop: true, quickFilters: [
                                    { id: 'today', label: t('today'), range: dateHelpers_1.getTodayRange },
                                    {
                                        id: 'thisWeek',
                                        label: t('thisWeek'),
                                        range: dateHelpers_1.getThisWeekRange,
                                    },
                                    {
                                        id: 'thisMonth',
                                        label: t('thisMonth'),
                                        range: dateHelpers_1.getThisMonthRange,
                                    },
                                ] })] }), activeFiltersComponent: (0, jsx_runtime_1.jsx)(ActiveFilterChips_1.ActiveFilterChips, { filters: displayFilters, optionsMap: optionsMap, onRemoveFilter: handleRemoveFilter }) }) }))] }));
};
exports.ClubInvoiceComponent = ClubInvoiceComponent;
